import { indexData } from '@/mocks/comicData';

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-10 text-center">
          {indexData.title}
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexData.items.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-xl p-5 border border-background-200/70 cursor-pointer hover:border-primary-200 hover:bg-primary-50/30 transition-colors text-center"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-100 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-1">
                {item.name}
              </h3>
              <p className="text-xs text-foreground-500">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}